import { z } from 'zod';
export const GetVidyardTokenQuerySchema = z
    .object({
    playerUuid: z.string(),
})
    .strict();
export const GetVidyardTokenResponseSchema = z.object({
    token: z.string(),
});
//# sourceMappingURL=endpoints.js.map